<template>
  <div
    class="ui-card-header peer/header z-10 w-full first:rounded-t-[inherit] last:mb-4"
    :class="{
      'px-4 pt-3': !noPadding,
      'bg-white/70 backdrop-blur-md': !noBackdropBlur,
    }"
    data-test-id="header"
  >
    <div
      class="ui-card-header-inner flex w-full flex-wrap"
      :class="{
        'items-center': alignItems === 'center',
        'align-start': alignItems === 'start',
        'items-end': alignItems === 'end',
      }"
    >
      <div :class="shrinkContent ? 'min-w-0 flex-1' : 'grow'">
        <slot />
      </div>
      <div v-if="$slots.actions" class="actions">
        <slot name="actions" />
      </div>
    </div>

    <div
      :class="{ 'card-underline': underline }"
      class="app-card-title-separator"
    />
  </div>
</template>

<script lang="ts" setup>
import type { IHeaderAlignItems } from './ui-card-types';

interface Props {
  underline?: boolean;
  noPadding?: boolean;
  alignItems?: IHeaderAlignItems;
  noBackdropBlur?: boolean;
  shrinkContent?: boolean;
}

withDefaults(defineProps<Props>(), {
  underline: false,
  noPadding: false,
  alignItems: 'center',
  noBackdropBlur: false,
  shrinkContent: false,
});
</script>

<style scoped lang="scss">
.card-underline {
  border-bottom: 1px solid
    var(--ui-card-header-underline-color, theme('colors.grey.300'));
  flex-basis: 100%;
  position: relative;
}

.card-title {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.ui-card-header-inner {
  min-height: 36px;
}

.prepend {
  margin-right: 0.5rem;
}

.actions {
  position: relative;
}
</style>
